---
id: apps-micro-services-docs-search-doc
title: Docs Search Service
owner: Engineering
status: Active
lastReviewed: 2026-01-26
visibility: internal
tags:
  - microservice
  - documentation
  - ai-agent
  - search
---

## Product Overview

AI-powered documentation search service that enables users to query and explore internal documentation using natural language. Provides visibility-aware responses that respect document access levels (public, internal, confidential).

## Technical Overview

FastAPI microservice that wraps a LangChain agent powered by Claude Haiku 4.5. The agent uses a sandboxed bash command tool to navigate and read documentation files.

Stack highlights:
- FastAPI
- LangChain + langchain-anthropic
- Claude Haiku 4.5 model
- uvicorn

Key components:
- `src/router.py`: Exposes `/search-docs` POST endpoint
- `src/agent.py`: Configures LangChain agent with read-only filesystem tools
- `src/docs/`: Documentation files in `.mdx` format

Security:
- Command allowlist restricts execution to read-only operations (ls, cat, find, grep, head, tail, wc, tree, file)
- Dangerous pattern detection prevents command injection

Deployment:
- Google Cloud Run (us-central1 or northamerica-northeast1)
- Environment variables: `ANTHROPIC_API_KEY`, `MY_ENV`

## Changelog

- 2026-01-23: Initial documentation.
